import { FormattedMessage } from 'react-intl';
import { VinPlaceholder } from 'src/easyclaim.app.components/common/ImageRepository';
import { getConfiguration } from 'src/easyclaim.app.configuration/configuration';
import { reportError } from 'src/easyclaim.app.libs/reportError';
import styled from 'styled-components';

import { AppState } from '../AppState';
import { EasyClaimDocumentType } from '../easyclaim.api.client.typescript/src/index';
import {
	DetailContainer,
	DetailsContainer,
	ExampleModalImage,
	SelectImage,
	StyledInfoIcon,
} from '../easyclaim.app.components/index';
import { ImageSelectionService } from '../easyclaim.app.services';

import { ScreenComponent } from './ScreenComponent';

interface VinPictureState {}

export class VinPicture extends ScreenComponent<AppState, VinPictureState> {
	constructor(props: AppState) {
		super(props);

		this.state = {};

		this.showVinImagesExampleModal = this.showVinImagesExampleModal.bind(this);
	}

	async showVinImagesExampleModal() {
		const useVinWindshieldImage = this.props.easyClaimCase!._configuration!.useVinWindshieldImge;
		const customerName = this.props.easyClaimCase?._configuration?.companyShortName;
		const imageSrcFromConfiguration = getConfiguration('exampleVinPicture', customerName);
		const baseUrl = `${process.env.PUBLIC_URL}/images/`;
		const imageSrcSufix = useVinWindshieldImage
			? 'example-vin-windshield.jpg'
			: imageSrcFromConfiguration;
		const imageSrc = baseUrl + imageSrcSufix;
		const images: ExampleModalImage[] = [
			{
				src: imageSrc,
			},
		];

		await this.props.showExampleModal(
			images,
			'vinImagesExampleModal.headline.first',
			'vinImagesExampleModal.button.close',
			'vin'
		);
	}

	public render() {
		return (
			<div className="main-container">
				<h2 className="vin-picture-title">
					<FormattedMessage id="vinPicture.title" />
				</h2>
				<DetailsContainer>
					<DetailContainer>
						<Paragraph>
							<FormattedMessage id="vinPicture.description" />{' '}
							<StyledInfoIcon
								onClick={() => {
									void this.showVinImagesExampleModal().catch((error: unknown) => {
										reportError(error, { context: 'VinPicture.asyncAction' });
									});
								}}
							/>
						</Paragraph>
						<SelectImage
							componentId="vinPicture"
							fileType={EasyClaimDocumentType.VinPicture}
							caseId={this.props.easyClaimCase?.caseId}
							easyClaimService={this.props.easyClaimService}
							currentImage={this.props.vinImage}
							title="vinPicture.headline"
							marginBottom="1rem"
							onChange={(image) => {
								const isImageLoading = ImageSelectionService.isImageLoading(image);

								const newState = Object.assign({}, this.props, {
									vinImage: image,
									isImageLoading: isImageLoading,
								});

								void this.props.setAppState(newState);
							}}
							onShowExample={() => {
								void this.showVinImagesExampleModal().catch((error: unknown) => {
									reportError(error, { context: 'VinPicture.showVinImagesExampleModal' });
								});
							}}
							showUserFeedbackInfo={true}
							placeholder={<VinPlaceholder />}
							configuration={this.props.easyClaimCase!._configuration!}
							inputError={this.props.inputError}
							canOverlayCamera={this.props.easyClaimCase?._configuration?.canShowOverlayOnCamera}
						/>
					</DetailContainer>
				</DetailsContainer>
			</div>
		);
	}
}

const Paragraph = styled.p`
	margin-bottom: 1rem;
	hyphens: auto;
	user-select: none;
	cursor: default;
`;
